export default __webpack_public_path__ + "static/media/doctor-personal.f9184846.svg";